const fileDownload = (response: Blob, fileName: string) => {
  const tempLink = document.createElement('a')
  tempLink.href = window.URL.createObjectURL(response)

  tempLink.setAttribute('download', `${fileName}.pdf`)
  document.body.appendChild(tempLink)
  tempLink.click()
  document.body.removeChild(tempLink)
}

export default fileDownload
